import { useState } from "react";

export function useByok() {
  const [provider, setProviderState] = useState(() => localStorage.getItem("byok_provider") || "openai");
  const [apiKey, setApiKeyState] = useState(() => localStorage.getItem("byok_key") || "");
  const setProvider = (v) => {
    setProviderState(v);
    localStorage.setItem("byok_provider", v);
  };
  const setApiKey = (v) => {
    setApiKeyState(v);
    localStorage.setItem("byok_key", v);
  };
  return { provider, apiKey, setProvider, setApiKey };
}
